import {cn} from '@/utils/utils';
import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
const ReceiveButtonItem = ({
  disabled,
  show,
}: {
  disabled?: boolean;
  show?: boolean;
}) => {
  const {i18n} = useTranslation();
  const disabledImg = useMemo(() => {
    const lang = i18n.language;
    const imgMap = {
      en_US: require('@/assets/imgs/vip/v2/btn-receive-gray.webp'),
      hi_IN: require('@/assets/imgs/vip/v2/btn-receive-gray-hi.webp'),
      te_IN: require('@/assets/imgs/vip/v2/btn-receive-gray-te.webp'),
      ml_IN: require('@/assets/imgs/vip/v2/btn-receive-gray-ml.webp'),
      ta_IN: require('@/assets/imgs/vip/v2/btn-receive-gray-ta.webp'),
    };
    return imgMap[lang as keyof typeof imgMap] || imgMap.en_US;
  }, [i18n]);
  const enabledImg = useMemo(() => {
    const lang = i18n.language;
    const imgMap = {
      en_US: require('@/assets/imgs/vip/v2/btn-receive-light.webp'),
      hi_IN: require('@/assets/imgs/vip/v2/btn-receive-light-hi.webp'),
      te_IN: require('@/assets/imgs/vip/v2/btn-receive-light-te.webp'),
      ml_IN: require('@/assets/imgs/vip/v2/btn-receive-light-ml.webp'),
      ta_IN: require('@/assets/imgs/vip/v2/btn-receive-light-ta.webp'),
    };
    return imgMap[lang as keyof typeof imgMap] || imgMap.en_US;
  }, [i18n]);
  return (
    <div
      className={cn(
        'absolute -left-[.4375rem] -right-[.4375rem] -bottom-3.5 top-0 bg-no-repeat bg-full',
        !show ? 'invisible' : '',
      )}
      style={{
        backgroundImage: `url(${disabled ? disabledImg : enabledImg})`,
      }}
    />
  );
};

const ModalReceiveButton = ({
  onClick,
  disabled,
  className,
}: {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'w-[13.8125rem] h-[3.5rem] relative overflow-visible mx-auto',
        className,
      )}
      onClick={onClick}>
      <ReceiveButtonItem disabled={true} show={disabled} />
      <ReceiveButtonItem show={!disabled} />
    </div>
  );
};

export default ModalReceiveButton;
